import { Client, ClientStatus } from "../../../../index";

const c001Client = new Client({
	id: "c001",
	slug: "airtable-super-extension",
	displayName: "Airtable Super Extension",
	description:
		"This browser extension hosts the core Airtable helper modules (rename attachments, download attachments, running totals, upload attachments) in one place. Switch between modules without reinstalling and keep configuration centralized across your workspace.",
	logoUrl:
		"https://storage.googleapis.com/cdn.version2.io/add-ons/c001/icons/c001_icon_rounded.png",
	oauth: {
		authUrl: "https://api.version2.io/v1/oauth/authorize",
		tokenUrl: "https://api.version2.io/v1/oauth/token",
		scopes: ["read", "write", "add-ons:manage"],
		clientId: "airtable-super-extension",
	},
	isDefaultEnabled: true,
	status: ClientStatus.ACTIVE,
});

export default c001Client;
